import { useEffect, useState } from "react";
import {
  categories,
  customerAPI,
  dieStatusAPI,
  locationAPI,
  supplierDieAPI,
  Unit,
  rawMaterials,
  SpectroCom,
  alloyAPI,
  DieTypeAPI,
  ToolingAPI,
  ToolingTypeAPI,
  departmentAPI,
} from "../../utlis/apiService";
import { notify } from "../Toast";
import InputField from "../InputField";

const ENTITY_CONFIG = {
  customer: {
    fields: [
      { name: "Name", label: "Name", required: true },
      { name: "Contact_No", label: "Contact No" },
      { name: "Gst_No", label: "GST No" },
      { name: "Address", label: "Address", required: true },
    ],
    api: customerAPI.saveOrUpdate,
    idField: "customer_Id",
    labelField: "name",
  },
  alloy: {
    fields: [{ name: "name", label: "Alloy Name", required: true }],
    api: alloyAPI.saveOrUpdate,
    idField: "id",
    labelField: "name",
  },
  dieType: {
    fields: [{ name: "name", label: "Die Type", required: true }],
    api: DieTypeAPI.saveOrUpdate,
    idField: "die_Type_Id",
    labelField: "name",
  },
  toolingSize: {
    fields: [{ name: "name", label: "Tooling Size", required: true }],
    api: ToolingAPI.saveOrUpdate,
    idField: "tooling_Size_Id",
    labelField: "name",
  },
  toolingType: {
    fields: [{ name: "name", label: "Tooling Type", required: true }],
    api: ToolingTypeAPI.saveOrUpdate,
    idField: "toolingTypeId",
    labelField: "name",
  },
  supplier: {
    fields: [
      { name: "Supplier_Name", label: "Supplier Name", required: true },
      { name: "Contact_No", label: "Contact No" },
      { name: "Contact_Person_Name", label: "Contact Person" },
      { name: "GST_No", label: "GST No" },
      { name: "Supplier_Address", label: "Address" },
    ],
    api: supplierDieAPI.saveOrUpdate,
    idField: "supplier_Id",
    labelField: "supplier_Name",
  },
  location: {
    fields: [{ name: "Name", label: "Location Name", required: true }],
    api: locationAPI.saveOrUpdate,
    idField: "location_Id",
    labelField: "name",
  },
  status: {
    fields: [
      { name: "status_Name", label: "Status Name", required: true },
      { name: "description", label: "Description" },
    ],
    api: dieStatusAPI.saveOrUpdate,
    idField: "id",
    labelField: "status_Name",
  },
  category: {
    fields: [{ name: "name", label: "Category Name", required: true }],
    api: categories.saveOrUpdate,
    idField: "id",
    labelField: "name",
  },
  unit: {
    fields: [{ name: "unit_Name", label: "Unit Name", required: true }],
    api: Unit.saveOrUpdate,
    idField: "unit_Id",
    labelField: "unit_Name",
  },
  rawMaterial: {
    fields: [
      { name: "name", label: "Raw Material Name", required: true },
      {
        name: "category_Id",
        label: "Category",
        required: true,
        type: "select",
        options: [],
      },
      {
        name: "unit_Id",
        label: "Unit",
        required: true,
        type: "select",
        options: [],
      },
    ],
    api: rawMaterials.saveOrUpdate,
    idField: "id",
    labelField: "name",
  },

  sampleSpectroComponent: {
    fields: [
      { name: "components_Name", label: "Spectro Component", required: true },
    ],
    api: SpectroCom.saveOrUpdate,
    idField: "components_Id",
    labelField: "components_Name",
  },
  finalSpectroComponent: {
    fields: [
      { name: "components_Name", label: "Spectro Component", required: true },
    ],
    api: SpectroCom.saveOrUpdate,
    idField: "components_Id",
    labelField: "components_Name",
  },
  department: {
    fields: [{ name: "department_Name", label: "Department", required: true }],
    api: departmentAPI.saveOrUpdate,
    idField: "department_Id",
    labelField: "department_Name",
  },
};

const EntityAddModal = ({ type, onClose }) => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);

  const config = ENTITY_CONFIG[type];

  const [formData, setFormData] = useState({
    ...Object.fromEntries(config.fields.map((f) => [f.name, ""])),
    created_By: userId,
  });

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  useEffect(() => {
    const loadDropdowns = async () => {
      if (type === "rawMaterial") {
        try {
          const [categoryRes, unitRes] = await Promise.all([
            categories.getAll(),
            Unit.getAll(),
          ]);

          setCategoryOptions(
            categoryRes.map((c) => ({ value: c.id, label: c.name })),
          );

          setUnitOptions(
            unitRes.map((u) => ({ value: u.unit_Id, label: u.unit_Name })),
          );
        } catch (err) {
          notify("Failed to load category/unit data", "error");
        }
      }
    };

    loadDropdowns();
  }, [type]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await config.api(formData);
      notify(`${config.title} successfully added`, "success");
      onClose();
    } catch {
      notify("Failed to save", "error");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="grid gap-4">
      <h3 className="text-lg font-semibold">{config.title}</h3>
      {config.fields.map((field) => {
        const fieldOptions =
          field.name === "category_Id"
            ? categoryOptions
            : field.name === "unit_Id"
              ? unitOptions
              : field.options || [];

        return (
          <InputField
            key={field.name}
            label={field.label}
            required={field.required}
            value={formData[field.name]}
            onChange={(val) => handleChange(field.name, val)}
            type={field.type || "text"}
            options={fieldOptions}
          />
        );
      })}

      <div className="flex justify-end gap-3">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 bg-gray-100 rounded-md text-sm"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-sky-600 text-white rounded-md text-sm"
        >
          Save
        </button>
      </div>
    </form>
  );
};

export default EntityAddModal;
